export default "__VITE_ASSET__D5cZbRMU__"